var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatewayIcon20240320042304(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 44.001,
    viewBox: "0 0 54 44.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gateway_Icon",
    "data-name": "Gateway Icon",
    transform: "translate(0 -19.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_152",
    "data-name": "Subtraction 152",
    d: "M9001-420h-36a9.01,9.01,0,0,1-9-9v-26a9.011,9.011,0,0,1,9-9h36a9.011,9.011,0,0,1,9,9v26A9.01,9.01,0,0,1,9001-420Zm-36-42a7.009,7.009,0,0,0-7,7v26a7.008,7.008,0,0,0,7,7h36a7.006,7.006,0,0,0,7-7v-26a7.008,7.008,0,0,0-7-7Z",
    transform: "translate(-8956 483.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9378",
    "data-name": "Path 9378",
    d: "M40,28H14a1,1,0,0,0-1,1V39a1,1,0,0,0,1,1H40a1,1,0,0,0,1-1V29A1,1,0,0,0,40,28ZM39,38H15V30H39ZM20,56H18a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Zm8,0H26a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Zm8,0H34a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9379",
    "data-name": "Path 9379",
    d: "M33,45a1,1,0,0,0-1-1H22a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H32a1,1,0,0,0,1-1Zm-2,5H23V46h8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayIcon20240320042304);
export default __webpack_public_path__ + "static/media/Gateway_Icon-20240320-042304.41c60a5c27b40128317942344fc8183c.svg";
export { ForwardRef as ReactComponent };